import React from 'react';
import { Button } from 'devextreme-react/button';
import EmptyState from './EmptyState';
import '../../styles/ErrorPage.scss';

const messages = {
  403: { title: 'Access denied', description: 'Your account does not have permission to open this page. Ask your administrator if you need access.', icon: 'lock' },
  404: { title: 'Page not found', description: 'This page may have moved, or the address may be incorrect.', icon: 'find' },
  500: { title: 'Something went wrong', description: 'We could not display this page. Try again, or return to the homepage.', icon: 'warning' },
  503: { title: 'Unable to connect', description: 'The server is taking too long to respond. Check your connection and try again.', icon: 'refresh' },
  load: { title: 'Unable to load data', description: 'We could not load these records. Try again in a moment.', icon: 'warning' },
};

export default function ErrorPage({ code = 500, onRetry, details }) {
  const message = messages[code] || messages[500];
  return (
    <section className="app-error-page" aria-labelledby="app-error-title" role="alert">
      <EmptyState icon={code === 403 ? '/icons/Profile.bmp' : code === 404 ? '/icons/Home.bmp' : '/icons/Notifications.bmp'} alt="" text={
        <>
          <span role="heading" aria-level={1} id="app-error-title" className="app-error-page__title">{message.title}</span>
          <span className="app-error-page__description">{message.description}</span>
        </>
      }>
        <div className="app-error-page__actions">
          {onRetry && <Button text="Try again" icon="refresh" stylingMode="outlined" onClick={onRetry} />}
          <a className="dx-button dx-button-mode-text app-error-page__home" href="/">Go to homepage</a>
        </div>
        {details && <details><summary>Technical details</summary><pre>{details}</pre></details>}
      </EmptyState>
    </section>
  );
}
